import { render, staticRenderFns } from "./DcpCert.vue?vue&type=template&id=67fd1116&"
import script from "./DcpCert.vue?vue&type=script&lang=js&"
export * from "./DcpCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports